import { NavLink, useMatch } from "react-router-dom";
import { useDashboards, useMe } from "../api/hooks";
import { useAuthSession } from "../api/auth";
import { useTheme } from "../theme/ThemeContext";
import { RosterAdminButton } from "./RosterEditor";

interface Props {
  onToggleCollapsed: () => void;
}

export function Sidebar({ onToggleCollapsed }: Props) {
  const { data: dashboards } = useDashboards();
  const { data: me } = useMe();
  const { data: session } = useAuthSession();
  const { theme, setTheme } = useTheme();
  const dashboardMatch = useMatch("/d/:id");

  return (
    <aside className="sidebar">
      <div className="sidebar-brand-row">
        <span className="sidebar-mark">
          <img src="/assets/silph-scope-mark.png" alt="Silph Scope" width={30} height={30} />
        </span>
        <span className="sidebar-wordmark">
          <strong>Silph Scope</strong>
          <span>Internal Analytics</span>
        </span>
        <button className="icon-btn" title="Toggle sidebar" onClick={onToggleCollapsed}>
          <i className="ri-side-bar-line" />
        </button>
      </div>

      <div className="sidebar-divider" />

      <div className="sidebar-section">
        <div className="eyebrow">Dashboards</div>
        <nav className="nav-list">
          {(dashboards ?? []).map((d) => (
            <NavLink key={d.id} to={`/d/${d.id}`} className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}>
              <i className={d.icon} />
              <span className="nav-label">{d.name}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="sidebar-section">
        <div className="eyebrow">Source</div>
        <div className="source-card">
          <div className="source-row">
            <i className="ri-checkbox-circle-fill" style={{ color: "var(--h-ok-fg)" }} />
            Asana → BigQuery
          </div>
        </div>
      </div>

      <div className="profile-card">
        <span className="avatar">{initialsOf(me?.name)}</span>
        <span className="profile-name">{me?.email ?? "…"}</span>
        <RosterAdminButton pageId={dashboardMatch?.params.id} variant="icon" />
        <span className="theme-toggle">
          <button className={theme === "light" ? "active" : ""} title="Light" onClick={() => setTheme("light")}>
            <i className="ri-sun-line" />
          </button>
          <button className={theme === "dark" ? "active" : ""} title="Dark" onClick={() => setTheme("dark")}>
            <i className="ri-moon-line" />
          </button>
        </span>
        {session?.cfg && !session.cfg.disabled ? (
          <a className="icon-btn" href={session.cfg.logoutUrl} title="Sign out">
            <i className="ri-logout-box-r-line" />
          </a>
        ) : null}
      </div>
    </aside>
  );
}

function initialsOf(name?: string): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? "") + (parts[1]?.[0] ?? "")).toUpperCase() || "?";
}
